/**
 * Type-safe helpers for reading/writing sessionStorage.
 *
 * Centralises the parse-or-fallback pattern that was duplicated
 * across appSlice, groupBySlice, and other Redux initialisers.
 */

/**
 * Read a JSON value from sessionStorage, returning `fallback` on missing or
 * malformed data.  Parsing errors are silently swallowed — the stored value
 * is treated as absent.
 */
export function getSessionItem<T>(key: string, fallback: T): T {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

/**
 * Write a value to sessionStorage as JSON.
 */
export function setSessionItem<T>(key: string, value: T): void {
  sessionStorage.setItem(key, JSON.stringify(value));
}
